import { render } from "./PackageIndex.vue?vue&type=template&id=d2a61dc8"
import script from "./PackageIndex.vue?vue&type=script&lang=js"
export * from "./PackageIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__